import request from "@/utils/request";

export default function agentGetDeviceNumDateil() {
    return request({
        url: `/device/device/agentGetDeviceNumDateil`,
    })
}
